import React, { Component } from 'react';
import _ from 'lodash';

import * as QuizHelpers from '../../helpers/quiz';

class Medicare extends Component {
  constructor (props) {
    super(props);
    this.state = {
      valid: props.quiz.fieldValues.Location.loc.Medicare,
      message: false,
      animate: ''
    };
    // Skip/redirect based on age
    const p = _.clone(props);
    const fieldValues = p.quiz.fieldValues;
    if (fieldValues.Age === '64') {
      QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Medicare?');
    } else if (fieldValues.Age > 64) {
      p.goToPreference();
    } else {
      p.nextStepNoAnimate();
    }
  }

  componentDidMount () {
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _nextStep (val) {
    let p = _.clone(this.props);
    if (val === true && this.state.valid === true) {
      p.reducer(val);
      p.stepMethods.setStep(p.quiz.step + 3);
      p.updateQuote('medicare');
    } else {
      p.reducer(val);
      p.stepMethods.setStep(p.quiz.step + 1);
    }
  }

  render () {
    let notice;
    if (!this.state.valid) {
      notice = <p className='info'>Unfortunately, we don&rsquo;t offer Medicare Advantage plans in your area.<br /> We invite you to use the <a href='https://www.medicare.gov/find-a-plan/questions/home.aspx' target='_blank' rel='noopener noreferrer'>government&rsquo;s Plan Finder</a>.</p>;
    }

    return (
      <section className={'p30 animate ' + this.state.animate}>
        <div className='wrap text-center'>
          <h3>Looking for a Medicare plan?</h3>
          <p className='form radio budget'>
            <input
              type='radio'
              name='medicare'
              value='yes'
              id='yes'
            /><label
              htmlFor='yes'
              onClick={(e) => this._nextStep(true)}>Yes</label>
            <input
              type='radio'
              name='medicare'
              value='no'
              id='no'
            /><label
              htmlFor='no'
              onClick={(e) => this._nextStep(false)}>No</label>
          </p>
          <div className={'message' + (notice ? ' show' : '')}>
            {notice}
          </div>
          <button className='btn back' onClick={this.props.stepMethods.prevStep}>Previous</button>
        </div>
      </section>
    );
  }
}

export default Medicare;
